import queryString from 'query-string';
import FilterQueryParams from 'src/adminPanel/entities/Filter';
import RequestEvent from 'src/adminPanel/entities/office/calendar/RequestEvent';
import RequestEventCommissionModel from 'src/adminPanel/entities/office/calendar/RequestEventCommissionModel';
import RequestEventLocation from 'src/adminPanel/entities/office/calendar/RequestEventLocation';
import RequestEventParticipant from 'src/adminPanel/entities/office/calendar/RequestEventParticipant';
import RequestEventType from 'src/adminPanel/entities/office/calendar/RequestEventType';
import RequestUpdateEventParticipant from 'src/adminPanel/entities/office/calendar/RequestUpdateEventParticipant';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

/* Event Event */
export const fetchEventEvents = (
    pageable: PageableQueryParams = {},
    filter: FilterQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable, ...filter }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events/list${query}`;
    return callApi(endpoint);
};

export const createNewEventEvent = (eventRequestDto: RequestEvent): Promise<CallApiResult> => {
    return callApi('/api/events/add', { method: 'POST', data: eventRequestDto });
};

export const updateEventEvent = (eventRequestDto: RequestEvent): Promise<CallApiResult> => {
    return callApi('/api/events/update', { method: 'PUT', data: eventRequestDto });
};

export const deleteEventEvent = (eventId: string): Promise<CallApiResult> => {
    return callApi('/api/events/delete/' + eventId, { method: 'DELETE' });
};

/* Event Commission Model */
export const fetchEventCommissionModels = (
    pageable: PageableQueryParams = {},
    filter: FilterQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, filter, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events/commissionModels/list${query}`;
    return callApi(endpoint);
};

export const createNewEventCommissionModel = (commissionModel: RequestEventCommissionModel): Promise<CallApiResult> => {
    return callApi('/api/events/commissionModels/add', { method: 'POST', data: commissionModel });
};

export const updateEventCommissionModel = (commissionModel: RequestEventCommissionModel): Promise<CallApiResult> => {
    return callApi('/api/events/commissionModels/update', { method: 'PUT', data: commissionModel });
};

export const deactivateEventCommissionModel = (modelId: string): Promise<CallApiResult> => {
    return callApi('/api/events/commissionModels/deactivate/' + modelId, { method: 'PUT' });
};

/* Event Location */
export const fetchEventLocations = (
    pageable: PageableQueryParams = {},
    filter: FilterQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, filter, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events/eventLocations/list${query}`;
    return callApi(endpoint);
};

export const createNewEventLocation = (eventLocation: RequestEventLocation): Promise<CallApiResult> => {
    return callApi('/api/events/eventLocations/add', { method: 'POST', data: eventLocation });
};

export const updateEventLocation = (eventLocation: RequestEventLocation): Promise<CallApiResult> => {
    return callApi('/api/events/eventLocations/update', { method: 'PUT', data: eventLocation });
};

export const deactivateEventLocation = (modelId: string): Promise<CallApiResult> => {
    return callApi('/api/events/eventLocations/deactivate/' + modelId, { method: 'PUT' });
};

/* Event Language Country Model */
export const fetchEventLanguageCountryModels = (
    pageable: PageableQueryParams = {},
    filter: FilterQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, filter, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events/languageCountryModels/list${query}`;
    return callApi(endpoint);
};

export const createNewEventLanguageCountryModel = (
    name: string,
    languages: string[],
    countries: string[]
): Promise<CallApiResult> => {
    return callApi('/api/events/languageCountryModels/add', {
        method: 'POST',
        data: { name, languages, countries },
    });
};

export const updateEventLanguageCountryModel = (
    id: string,
    name: string,
    languages: string[],
    countries: string[]
): Promise<CallApiResult> => {
    return callApi('/api/events/languageCountryModels/update', {
        method: 'PUT',
        data: { id, name, languages, countries },
    });
};

export const deactivateEventLanguageCountryModel = (modelId: string): Promise<CallApiResult> => {
    return callApi('/api/events/languageCountryModels/deactivate/' + modelId, { method: 'PUT' });
};

/* Event Type */
export const fetchEventTypes = (
    pageable: PageableQueryParams = {},
    filter: FilterQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, filter, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events/eventTypes/list${query}`;
    return callApi(endpoint);
};

export const createNewEventType = (eventTypeRequest: RequestEventType): Promise<CallApiResult> => {
    return callApi('/api/events/eventTypes/add', { method: 'POST', data: eventTypeRequest });
};

export const updateEventType = (eventTypeRequest: RequestEventType): Promise<CallApiResult> => {
    return callApi('/api/events/eventTypes/update', { method: 'PUT', data: eventTypeRequest });
};

export const deactivateEventType = (eventTypeId: string): Promise<CallApiResult> => {
    return callApi('/api/events/eventTypes/deactivate/' + eventTypeId, { method: 'PUT' });
};

/* Event Participant */
export const fetchEventParticipant = (eventId: string, pageable: PageableQueryParams = {}): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/eventParticipants/${eventId}/list${query}`;
    return callApi(endpoint);
};

export const createNewEventParticipant = (eventParticipant: RequestEventParticipant): Promise<CallApiResult> => {
    return callApi('/api/eventParticipants/add', { method: 'POST', data: eventParticipant });
};

export const updateEventParticipant = (
    eventUpdateParticipant: RequestUpdateEventParticipant
): Promise<CallApiResult> => {
    return callApi('/api/eventParticipants/update', { method: 'PUT', data: eventUpdateParticipant });
};

export const deleteEventParticipant = (eventParticipantId: string): Promise<CallApiResult> => {
    return callApi('/api/eventParticipants/delete/' + eventParticipantId, { method: 'DELETE' });
};
